import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyServiceFilterPipe } from './myServicefilter';
import { FilterByNamePipe } from './filterByName';
import { SafeUrlPipe } from './safeUrl';
import { FilterByAddonsType, FilterByCartItems, FilterByCategoryId } from './filterByAddonType';
import { FilterAttendee, FilterEventAttendee } from './filterEventAttendee';
import { FilterReportDataByTitle } from './filterReportTitle';
import { FilterByWhatsappGroupType } from './filterByGroupType';
import { FilterByWhatsappGroupPipe } from './filterByWhatsappGroup';
import { VisitationFilterPipe } from './filterVisitationFamily';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    MyServiceFilterPipe, FilterByNamePipe, SafeUrlPipe, FilterByAddonsType, FilterByCartItems, FilterEventAttendee, FilterAttendee, FilterByCategoryId, FilterReportDataByTitle, FilterByWhatsappGroupType, FilterByWhatsappGroupPipe, VisitationFilterPipe
  ],
  declarations: [
    MyServiceFilterPipe, FilterByNamePipe, SafeUrlPipe, FilterByAddonsType, FilterByCartItems, FilterEventAttendee, FilterAttendee, FilterByCategoryId, FilterReportDataByTitle, FilterByWhatsappGroupType, FilterByWhatsappGroupPipe, VisitationFilterPipe
  ]
})
export class PipeModule { }